// src/components/DevErrorBoundary.js
import React from "react";

export default class DevErrorBoundary extends React.Component {
  constructor(p){ super(p); this.state = { error: null }; }
  static getDerivedStateFromError(error){ return { error }; }
  render(){
    if (this.state.error) {
      return (
        <div style={{padding:16, background:"#fee2e2", color:"#991b1b", borderRadius:12}}>
          <div style={{fontWeight:700, marginBottom:8}}>Render error in this area</div>
          <pre style={{whiteSpace:"pre-wrap"}}>{String(this.state.error?.stack || this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
